import isObject from 'lodash/isObject';
import merge from 'lodash/merge';
import AppDBStorage from '@Services/AppDBStorage';

class SearchStorage extends AppDBStorage {
  constructor() {
    super('searchId_');
  }

  // eslint-disable-next-line class-methods-use-this
  getDefaultValue() {
    return {};
  }

  extendItem(key, src) {
    return this._change(key, (item) => {
      if (item && isObject(item)) {
        return merge(item, src);
      }
      return item;
    });
  }
}

const searchStorage = new SearchStorage();

export default searchStorage;
